<template>
  <div id="info" class="menu-tab">
    <div class="menu-tab-content">
      <div class="page-info" v-if="evenPageText && spread">
        <h1>{{ `Side ${evenPage.pageNumber}` }}</h1>
        <p v-html="evenPageText"></p>
      </div>
      <div class="page-info" v-if="oddPageText && spread">
        <h1>{{ `Side ${oddPage.pageNumber}` }}</h1>
        <p v-html="oddPageText"></p>
      </div>
      <div class="page-info" v-if="currentPageText && !spread">
        <h1>{{ `Side ${currentPage.pageNumber}` }}</h1>
        <p v-html="currentPageText"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import bookTools from '@/utils/book'
export default {
  computed: {
    ...mapGetters([
      'oddPage',
      'evenPage',
      'currentPage',
      'spread'
    ]),
    oddPageText () {
      if (this.oddPage !== null && this.oddPage.description != null) {
        return bookTools.replaceLineBreaks(this.oddPage.description)
      } else {
        return null
      }
    },
    evenPageText () {
      if (this.evenPage !== null && this.evenPage.description != null) {
        return bookTools.replaceLineBreaks(this.evenPage.description)
      } else {
        return null
      }
    },
    currentPageText () {
      if (this.currentPage.description != null) {
        return bookTools.replaceLineBreaks(this.currentPage.description)
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped>
  h1 {
    font-size: 0.9em;
    margin-bottom: 0.2em;
  }
  p {
    font-size: 0.9em;
  }

  .page-info {
    margin-bottom: 30px;
  }

  .page-info:last-child {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageInfoTab.vue